import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'
import { Dep0405CtlrIn, Dep0405CtlrOut } from 'app/core/models/api/dep/dep0405'
import { Dep0302CtlrIn, Dep0302CtlrOut } from 'app/core/models/api/dep/dep0302'
import { Dep0403CtlrIn, Dep0403CtlrOut } from 'app/core/models/api/dep/dep0403'
import { Dep0201CtlrIn, Dep0201CtlrOut } from 'app/core/models/api/dep/dep0201'
import { Dep0202CtlrIn, Dep0202CtlrOut } from 'app/core/models/api/dep/dep0202'
import { Dep0407CtlrOut, Dep0407CtlrIn } from 'app/core/models/api/dep/dep0407'
import { Dep0408CtlrOut, Dep0408CtlrIn } from 'app/core/models/api/dep/dep0408'
import { Dep0103CtlrIn, Dep0103CtlrOut } from 'app/core/models/api/dep/dep0103'
import { Dep0105CtlrOut } from 'app/core/models/api/dep/dep0105'
import { Dep0102CtlrOut, Dep0102CtlrIn } from 'app/core/models/api/dep/dep0102'
import { Dep0204CtlrOut, Dep0204CtlrIn } from 'app/core/models/api/dep/dep0204'
import { Dep0206CtlrOut, Dep0206CtlrIn } from 'app/core/models/api/dep/dep0206'
import { Dep0205CtlrOut } from 'app/core/models/api/dep/dep0205'
import { Dep0101CtlrIn, Dep0101CtlrOut } from 'app/core/models/api/dep/dep0101'
import { Dep0207CtlrOut, Dep0207CtlrIn } from 'app/core/models/api/dep/dep0207'
import { Dep0402CtlrOut, Dep0402CtlrIn } from 'app/core/models/api/dep/dep0402'
import { Dep0401CtlrOut, Dep0401CtlrIn } from 'app/core/models/api/dep/dep0401'
import { Dep0203CtlrOut, Dep0203CtlrIn } from 'app/core/models/api/dep/dep0203'
import { Dep0409CtlrOut, Dep0409CtlrIn } from 'app/core/models/api/dep/dep0409'
import { Dep0410CtlrOut, Dep0410CtlrIn } from 'app/core/models/api/dep/dep0410'
import { Crd0105CtlrIn, Crd0105CtlrOut } from 'app/core/models/api/crd/crd0105'
import { Crd0202CtlrOut } from 'app/core/models/api/crd/crd0202'
import { Crd0203CtlrOut, Crd0203CtlrIn } from 'app/core/models/api/crd/crd0203'
import { Dep0411CtlrOut, Dep0411CtlrIn } from 'app/core/models/api/dep/dep0411'
import { Dep0209CtlrOut, Dep0209CtlrIn } from 'app/core/models/api/dep/dep0209'
import { Dep0210CtlrOut, Dep0210CtlrIn } from 'app/core/models/api/dep/dep0210'
import { Dep0211CtlrOut, Dep0211CtlrIn } from 'app/core/models/api/dep/dep0211'

let suffixPath = 'prd/dep'
let suffixPath1 = 'prd/crd'

export const postApi = api
    //dep01
    .injectEndpoints({
        endpoints: (build) => ({
            //고객 등록
            selectDep0101: build.query<Dep0101CtlrOut, Dep0101CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep01/dep0101`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0101CtlrOut>,
            }),
            //고객 계좌 목록 선 조회
            selectDep0102: build.query<Dep0102CtlrOut, Dep0102CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep01/dep0102`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0102CtlrOut>,
            }),
            //고객상품 가입 가능 여부 조회
            selectDep0103: build.query<Dep0103CtlrOut, Dep0103CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep01/dep0103`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0103CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
            selectDep0103False: build.query<Dep0103CtlrOut, Dep0103CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep01/dep0103`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0103CtlrOut>,
            }),
            //이어가기 조회(단건)
            selectDep0105: build.query<Dep0105CtlrOut, {}>({
                query: () => ({
                    url: `${suffixPath}/dep01/dep0105`,
                    method: 'POST',
                    body: {},
                }),
                transformResponse: CommonResponse<Dep0105CtlrOut>,
            }),
        }),
    })
    //dep02
    .injectEndpoints({
        endpoints: (build) => ({
            // 계좌신규
            selectDep0201: build.query<Dep0201CtlrOut, Dep0201CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0201`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0201CtlrOut>,
            }),
            // 약관정보를 조회
            selectDep0202: build.query<Dep0202CtlrOut, Dep0202CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0202`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0202CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
            // 고객의 관리부점 확인
            selectDep0203: build.query<Dep0203CtlrOut, Dep0203CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0203`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0203CtlrOut>,
            }),
            // 자동이체 계좌비번검증
            selectDep0204: build.query<Dep0204CtlrOut, Dep0204CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0204`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0204CtlrOut>,
            }),
            // 우대금리조건을 조회
            selectDep0205: build.query<Dep0205CtlrOut, {}>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0205`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0205CtlrOut>,
            }),
            // 상품가입만기예상금액시뮬레이션조회
            selectDep0206: build.query<Dep0206CtlrOut, Dep0206CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0206`,
                    method: 'POST',
                    body,
                }),
                extraOptions: { handleLocally: true },
                transformResponse: CommonResponse<Dep0206CtlrOut>,
            }),
            // 계좌잔액조회
            selectDep0207: build.query<Dep0207CtlrOut, Dep0207CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep02/dep0207`,
                    method: 'POST',
                    body,
                }),
                extraOptions: { handleLocally: true },
                transformResponse: CommonResponse<Dep0207CtlrOut>,
            }),
			// 비즈허브 비대면쿠폰연계
			selectDep0209: build.query<Dep0209CtlrOut, Dep0209CtlrIn>({
				query: (body) => ({
					url: `${suffixPath}/dep02/dep0209`,
					method: 'POST',
					body,
				}),
				transformResponse: CommonResponse<Dep0209CtlrOut>,
			}),
			// 비대면채널참여이벤트 참여이력 조회
			selectDep0210: build.query<Dep0210CtlrOut, Dep0210CtlrIn>({
				query: (body) => ({
					url: `${suffixPath}/dep02/dep0210`,
					method: 'POST',
					body,					
				}),
				transformResponse: CommonResponse<Dep0210CtlrOut>,
			}),
			// 비대면채널참여이벤트 참여
			selectDep0211: build.query<Dep0211CtlrOut, Dep0211CtlrIn>({
				query: (body) => ({
					url: `${suffixPath}/dep02/dep0211`,
					method: 'POST',
					body,					
				}),
				transformResponse: CommonResponse<Dep0211CtlrOut>,
			})			
        }),
    })
    //dep03
    .injectEndpoints({
        endpoints: (build) => ({
            // 상품상세조회
            selectDep0302: build.query<Dep0302CtlrOut, Dep0302CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep03/dep0302`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0302CtlrOut>,
            }),
        }),
    })
    //dep04
    .injectEndpoints({
        endpoints: (build) => ({
            // 군인공제회고객 조회
            selectDep0401: build.query<Dep0401CtlrOut, Dep0401CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0401`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0401CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
            // 중소기업재직정보여부 조회
            selectDep0402: build.query<Dep0402CtlrOut, Dep0402CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0402`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0402CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
            // 평생계좌번호 중복여부 조회
            selectDep0403: build.query<Dep0403CtlrOut, Dep0403CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0403`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0403CtlrOut>,
            }),
            // 예금금리상세조회
            selectDep0405: build.query<Dep0405CtlrOut, Dep0405CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0405`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0405CtlrOut>,
            }),
            // 청약통장신규가입자 정보조회
            selectDep0407: build.query<Dep0407CtlrOut, Dep0407CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0407`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0407CtlrOut>,
            }),
            // 청약통장신규가입자 등록
            selectDep0408: build.query<Dep0408CtlrOut, Dep0408CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0408`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0408CtlrOut>,
            }),
            // 개인정보동의서정보 변경
            selectDep0409: build.query<Dep0409CtlrOut, Dep0409CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0409`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0409CtlrOut>,
            }),
            // 나라사랑카드 사전신청정보 조회
            selectDep0410: build.query<Dep0410CtlrOut, Dep0410CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath}/dep04/dep0410`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Dep0410CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
			// 생계비통장개설 여부 조회
			selectDep0411: build.query<Dep0411CtlrOut, Dep0411CtlrIn>({
				query: (body) => ({
					url: `${suffixPath}/dep04/dep0411`,
					method: 'POST',
					body, 
				}),
				transformResponse: CommonResponse<Dep0411CtlrOut>,
				extraOptions: { handleLocally: true },
			})
        }),
    })
    //crd01
    .injectEndpoints({
        endpoints: (build) => ({
            // 상품상세조회
            selectCrd0105: build.query<Crd0105CtlrOut, Crd0105CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath1}/crd01/crd0105`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Crd0105CtlrOut>,
            }),
        }),
    })
    //crd02
    .injectEndpoints({
        endpoints: (build) => ({
            // 나라사랑카드 보유확인
            selectCrd0202: build.query<Crd0202CtlrOut, {}>({
                query: (body) => ({
                    url: `${suffixPath1}/crd02/crd0202`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Crd0202CtlrOut>,
                extraOptions: { handleLocally: true },
            }),
            // 네이버페이 포인트서비스 사후연동
            selectCrd0203: build.query<Crd0203CtlrOut, Crd0203CtlrIn>({
                query: (body) => ({
                    url: `${suffixPath1}/crd02/crd0203`,
                    method: 'POST',
                    body,
                }),
                transformResponse: CommonResponse<Crd0203CtlrOut>,
            }),
        }),
    })

export const {
    useLazySelectDep0101Query,
    useLazySelectDep0102Query,
    useLazySelectDep0103Query,
    useLazySelectDep0103FalseQuery,
    useLazySelectDep0105Query,
    useLazySelectDep0201Query,
    useLazySelectDep0202Query,
    useLazySelectDep0203Query,
    useLazySelectDep0204Query,
    useLazySelectDep0205Query,
    useLazySelectDep0206Query,
    useLazySelectDep0207Query,
	useLazySelectDep0209Query,
	useLazySelectDep0210Query,
	useLazySelectDep0211Query,	
    useLazySelectDep0302Query,
    useLazySelectDep0401Query,
    useLazySelectDep0402Query,
    useLazySelectDep0403Query,
    useLazySelectDep0405Query,
    useLazySelectDep0407Query,
    useLazySelectDep0408Query,
    useLazySelectDep0409Query,
    useLazySelectDep0410Query,
	useLazySelectDep0411Query,
    useLazySelectCrd0105Query,
    useLazySelectCrd0202Query,
    useLazySelectCrd0203Query,

} = postApi

export const {
    endpoints: {
        selectDep0101,
        selectDep0102,
        selectDep0103,
        selectDep0103False,
        selectDep0105,
        selectDep0202,
        selectDep0203,
        selectDep0204,
        selectDep0205,
        selectDep0206,
        selectDep0207,
 		selectDep0209,
		selectDep0210,
		selectDep0211,       
		selectDep0302,
        selectDep0401,
        selectDep0402,
        selectDep0403,
        selectDep0405,
        selectDep0410,
		selectDep0411,
        selectCrd0105,
        selectCrd0202,
        selectCrd0203,

    },
} = postApi
